import { render, staticRenderFns } from "./emailAuth.vue?vue&type=template&id=61a6caea&scoped=true&"
import script from "./emailAuth.vue?vue&type=script&lang=js&"
export * from "./emailAuth.vue?vue&type=script&lang=js&"
import style0 from "./emailAuth.vue?vue&type=style&index=0&id=61a6caea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6caea",
  null
  
)

export default component.exports